import { useTranslation } from "@ferrivia/i18n";
import { StepLayout } from "../components/StepLayout";

export interface IntroStepProps {
  givenName: string | null;
}

/**
 * Bank ID already told us who this is, so onboarding greets by name rather
 * than asking for it — one fewer question than the Glide form, and a signal
 * that the sign-in worked.
 */
export function IntroStep({ givenName }: IntroStepProps) {
  const { t } = useTranslation("client");

  // Two different sentence shapes, not one interpolated into a blank — so
  // two keys rather than one with a conditional argument.
  const title = givenName
    ? t("onboarding.intro.titleWithName", "Tervetuloa, {{givenName}}", { givenName })
    : t("onboarding.intro.title", "Tervetuloa Ferriviaan");

  return (
    <StepLayout
      title={title}
      subtitle={t(
        "onboarding.intro.body",
        "Muutama kysymys, niin voimme palvella sinua paremmin. Tämä vie noin minuutin.",
      )}
    >
      {null}
    </StepLayout>
  );
}
